<template>
	<vx-card>
		<vs-popup
			:active.sync="showValidationPopup"
			title="Êtes-vous sûr de vouloir supprimer cette mission ?"
		>
			<div class="vx-row">
				<div class="vx-col sm:w-1/2">
					<vs-button class="mt-2 w-full" @click="acceptDeleteMission()"
						>Oui</vs-button
					>
				</div>
				<div class="vx-col sm:w-1/2">
					<vs-button class="mt-2 w-full" @click="declineDeleteMission()"
						>Non</vs-button
					>
				</div>
			</div>
		</vs-popup>
		<vs-button
			class="float-right"
			radius
			color="primary"
			type="filled"
			icon-pack="feather"
			icon="icon-x"
			@click="returnPrevRoute"
		></vs-button>
		<form-wizard
			ref="formwizard"
			color="rgba(var(--vs-primary), 1)"
			title="Modification d'un contrat"
			:subtitle="
				'Modifiez les prestations du contrat N°' + $route.params.contractId
			"
			nextButtonText="Suivant"
			backButtonText="Retour"
			finishButtonText="Enregistrer"
			:start-index="$route.params.startIndex"
		>
			<div title="Modification des prestations" class="mb-5">
				<div class="vx-col" v-if="contractMissions && !clickAddMission">
					<div class="vx-row center_div no_max_width">
						<vs-table
							:data="contractMissions"
							class="table_sizing"
							noDataText="Aucune prestation."
						>
							<template slot="thead">
								<vs-th>Prestation(s)</vs-th>
								<vs-th>Commentaire</vs-th>
								<vs-th>Récurrence</vs-th>
								<vs-th>Tarif</vs-th>
								<vs-th>Temps maximum</vs-th>
								<vs-th>Prix Collaborateur Externe</vs-th>
								<vs-th>Nombre de points</vs-th>
								<vs-th></vs-th>
								<vs-th></vs-th>
								<vs-th></vs-th>
							</template>

							<template slot-scope="{ data }">
								<vs-tr :key="indextr" v-for="(tr, indextr) in data">
									<vs-td>{{ getProductName(data[indextr].products_id) }}</vs-td>
									<vs-td>{{ data[indextr].commentary }}</vs-td>
									<vs-td v-if="data[indextr].recurrence">{{
										getContractFrequency(data[indextr].frequency)
									}}</vs-td>
									<vs-td v-else>{{
										getContractRecurrence(data[indextr].recurrence)
									}}</vs-td>
									<vs-td style="white-space: nowrap">{{
										getInfo(
											"price",
											data[indextr].price,
											data[indextr].price_text
										)
									}}</vs-td>
									<vs-td style="white-space: nowrap">{{
										getInfo("timeLimit", data[indextr].time_limit)
									}}</vs-td>
									<vs-td>{{ data[indextr].provider_price_text }}</vs-td>
									<vs-td>{{
										getInfo("meetingNumber", data[indextr].meeting_number)
									}}</vs-td>
									<vs-td>
										<div class="flex center">
											<vs-chip
												style="width: 80px"
												:color="getContractStatusColor(data[indextr].status)"
											>
												{{ getContractStatus(data[indextr].status) }}
											</vs-chip>
										</div>
									</vs-td>
									<vs-td>
										<vx-tooltip text="Modifier" position="top">
											<vs-button
												size="large"
												color="primary"
												type="flat"
												icon-pack="feather"
												icon="icon-edit-2"
												@click="updateMission(tr)"
											></vs-button>
										</vx-tooltip>
									</vs-td>
									<vs-td v-if="$acl.check('sadmin')">
										<vx-tooltip text="Effacer" position="top">
											<vs-button
												size="large"
												color="danger"
												type="flat"
												icon-pack="feather"
												icon="icon-trash-2"
												@click="showDeletePopup(tr.id)"
											></vs-button>
										</vx-tooltip>
									</vs-td>
								</vs-tr>
							</template>
						</vs-table>
					</div>
				</div>
				<div class="vx-col mt-4">
					<div class="vx-row center_div">
						<vs-button
							type="filled"
							@click="displayMissionForContract(false)"
							v-if="!clickAddMission"
							>Ajouter une prestation</vs-button
						>
					</div>
					<div ref="popupContainer">
						<!-- GENERER DYNAMIQUEMENT -->
					</div>
				</div>
			</div>

			<!-- CONTROL UI FOOTER BUTTON -->
			<template slot="footer" slot-scope="props">
				<div class="wizard-footer-right">
					<wizard-button
						v-if="!clickAddMission"
						@click.native="returnPrevRoute"
						class="wizard-footer-right finish-button"
						:style="props.fillButtonStyle"
						>Enregistrer</wizard-button
					>
				</div>
			</template>
		</form-wizard>
	</vx-card>
</template>

<script>
import Vue from "vue";
import VueCookies from "vue-cookies";
import store from "@/store/store";

import utilsMixin from "@/mixins/utilsMixin";
import dbFieldConvertor from "@/mixins/dbFieldConvertorMixin";
import validatorMixin from "@/mixins/validatorMixin";
import Validator from "@/entities/Validator";

import Contract from "@/entities/Contract";
import { FormWizard, WizardButton } from "vue-form-wizard";
import Mission from "@/entities/Mission";
import MissionForContract from "../mission/MissionForContract";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import VxTooltip from "./../../../components/widgets/vx-tooltip/VxTooltip.vue";

export default {
	name: "UpdateContractMissionsForm",
	mixins: [utilsMixin, dbFieldConvertor, validatorMixin],
	components: {
		FormWizard,
		WizardButton,
		VxTooltip,
	},
	data() {
		return {
			contractMissions: [],
			missionsAdded: 0,
			clickAddMission: false,
			apiUrl: this.$store.state.backendApiUrl,
			// FORM SELECT OPTIONS
			accountmanagerOptions: [],

			// FORM FIELDS
			contract: Contract.getFormFields(),
			contractOld: Contract.getFormFields(),
			commercialId: null,
			selectedAccountManager: null,
			accountmanagerList: [],
			productOptions: [],
			lead_account_manager: [],
			lead_account_manager_On: false,
			selectedSociety: null,
			showValidationPopup: false,
			showValidateTaskTablePopup: false,
			missionToDelete: null,
			previous_status: null,
			current_status: null,
			validators: {},
			check: true,
			userInfos: {},
			checkPage: false,
			task: [],
		};
	},
	mounted() {
		this.$http
			.get(this.apiUrl + "contract/get/" + this.$route.params.contractId)
			.then((contract) => {
				this.contract = new Contract(contract.data[0]);
				this.current_status = this.contract.status;
				this.previous_status = this.contract.status;
				this.contractOld = new Contract(contract.data[0]);
				this.contract.account_managers = [];
				this.contractOld.account_managers = [];
				this.getContractMission(this.contract.id);
				Contract.getRankwellforContract(contract.data[0].id, (err, res) => {
					if (err)
						if (res) {
							//console.log(err);
							for (let collaborator of res.data) {
								if (collaborator.type == 0) {
									this.contract.commercial_id = collaborator.users_id;
									this.commercialId = collaborator.users_id;
								} else {
									//ADD collaborator.is_lead
									let addedCollaborator = this.accountmanagerOptions.find(
										(accountmanager) =>
											accountmanager.id == collaborator.users_id
									);
									addedCollaborator.is_lead = collaborator.is_lead;
									this.contract.account_managers.push(addedCollaborator);
									let addedCollaboratorOld = Object.assign(
										{},
										addedCollaborator
									);
									this.contractOld.account_managers.push(addedCollaboratorOld);
									this.accountmanagerList.push(addedCollaborator);
								}
							}
							for (let account_manager of this.contract.account_managers) {
								if (account_manager.is_lead == 1) {
									this.lead_account_manager = account_manager;
									this.lead_account_manager_On = true;
								}
							}
						}
				});
			})
			.catch((err) => {
				//console.log(err);
			});
	},
	computed: {
		activeUser() {
			return VueCookies.get("userInfo");
		},
		products_categories: () => {
			return store.state.products_categories;
		},
	},
	watch: {
		/**
		 * Once the user add a mission
		 * Refresh data by getting all the missions for the current contract
		 */
		missionsAdded: function () {
			this.getContractMission(this.contract.id);
		},
	},
	beforeUnmount() {
		// Find and remove any lingering tooltip elements
		const tooltips = document.querySelectorAll(".vx-tooltip-content");
		tooltips.forEach((tooltip) => tooltip.remove());
	},
	created() {
		this.getAllSocieties();
		this.getAllAccountManagers();
		this.getAllProducts();
		this.getAllProductsCategories();
	},
	methods: {
		getAllProductsCategories() {
			this.$store.dispatch("getAllProductsCategories");
		},
		/**
		 * Query our API to fetch all the societies
		 */
		getAllSocieties() {
			this.$store.dispatch("getAllSocietiesIdAndName");
		},

		/**
		 * Query our API to fetch all the commercials
		 */
		getAllAccountManagers() {
			this.$http
				.get(this.apiUrl + "users/all/accountmanager")
				.then((res) => {
					this.accountmanagerOptions = res.data;
				})
				.catch((err) => {
					console.error(err);
				});
		},
		getCurrentUser() {
			this.$http
				.get(this.apiUrl + "users/get/" + this.activeUser.id)
				.then((res) => {
					this.userInfos = res.data;
					console.log("use:m ", userInfos);
				})
				.catch((err) => {
					console.log(err);
					console.error(err);
				});
		},

		/**
		 * Query our API to fetch all products
		 */
		getAllProducts() {
			this.$http
				.get(this.apiUrl + "product/all/")
				.then((res) => {
					this.productOptions = res.data;
				})
				.catch((err) => {
					console.error(err);
				});
		},

		getInfo(type, val, txt = null) {
			if (type == "price") {
				if (txt) return txt;
				else {
					if (
						val == "" ||
						val == 0 ||
						val == "0" ||
						val == "null" ||
						val == null
					)
						return "0 €";
					else return val + " €";
				}
			} else if (type == "timeLimit") {
				if (val == "" || val == 0 || val == "0" || val == "null" || val == null)
					return "";
				else return val + " h";
			} else {
				if (val == "" || val == 0 || val == "0" || val == "null" || val == null)
					return "";
				else return val;
			}
		},

		/**
		 * Returns product's name from product's id
		 */
		getProductName(product_id) {
			let product_name = "";
			let product_name_object = this.productOptions.find(
				(product) => product.id == product_id
			);
			product_name = product_name_object.perform;
			return product_name;
		},

		/**
		 * Query our api to fetch all the mission linked to a contract
		 */
		getContractMission(contractId) {
			this.$http
				.get(this.apiUrl + "mission/get/contract/" + contractId)
				.then((res) => {
					this.contractMissions = res.data;
					this.missionsAdded = this.contractMissions.length;
				})
				.catch((err) => {
					console.error(err);
				});
		},

		/**
		 * Création et affichage du popup de création de mission
		 */
		displayMissionForContract(isEdit, mission = null) {
			//Initialisation des données pour le popup
			if (mission !== null) {
				let re = new RegExp("([T|Z])", "g");
				if (mission.start_date)
					mission.start_date = mission.start_date.replace(re, " ");
				if (mission.end_date)
					mission.end_date = mission.end_date.replace(re, " ");
			}
			this.clickAddMission = true;
			let propsData = isEdit
				? {
						propsData: {
							contract: this.contract,
							missionToModify: mission,
							show: this.clickAddMission,
							apiUrl: this.apiUrl,
							router: this.$router,
							editMode: isEdit,
							editContract: true,
						},
				  }
				: {
						propsData: {
							contract: this.contract,
							show: this.clickAddMission,
							apiUrl: this.apiUrl,
							router: this.$router,
							editMode: isEdit,
							editContract: true,
						},
				  };

			//Instancie la class SocietyInfoPopup pour mount sur la balise div principale
			let ComponentClass = Vue.extend(MissionForContract);
			let missionPopup = new ComponentClass(propsData);
			missionPopup.$mount();
			missionPopup.$on("close-form", () => {
				this.closeMissionForm();
			});
			missionPopup.$on("close-form-after-added", (event) => {
				this.refreshData(event);
			});
			this.$refs.popupContainer.appendChild(missionPopup.$el);
		},

		updateMission(mission) {
			if (this.contract.status == 4) {
				this.$vs.notify({
					title: "Echec",
					text: "Vous ne pouvez pas modifier les missions d'un contrat terminé.",
				});
			} else {
				this.displayMissionForContract(true, mission);
			}
		},

		deleteMission(missionId) {
			Mission.delete(missionId, this.activeUser.id, (err, res) => {
				if (err)
					if (res) {
						//console.log(err);
						this.missionsAdded -= 1;
					}
			});
		},

		showDeletePopup(missionId) {
			this.missionToDelete = missionId;
			this.showValidationPopup = true;
		},

		acceptDeleteMission() {
			this.deleteMission(this.missionToDelete);
			this.showValidationPopup = false;
		},

		declineDeleteMission() {
			this.missionToDelete = null;
			this.showValidationPopup = false;
		},

		validateOne(val, name) {
			let value = val;
			value == 0 ? (value = "0") : "";
			let constname = "";
			switch (name) {
				case "society_id":
				case "early_cancellation_duration":
				case "engagement_duration":
				case "commercial_id":
					value ? (value = String(val)) : "";
					value == null ? (value = "") : "";
					constname = "isNumberConstraint";
					break;
				case "commentary":
				case "detail":
					constname = "commentaryConstraint";
					break;
				default:
					break;
			}
			this.validators[name] = new Validator({ constraintName: constname });
			this.validators[name].check(value);
			if (
				this.validators[name].valid == false &&
				this.validators[name].errText == ""
			) {
				if (name == "society_id" || name == "commercial_id") {
					this.validators[name].errText = "Ce champ ne peut être vide.";
				} else if (
					this.contract.early_cancellation &&
					name == "early_cancellation_duration"
				) {
					this.validators[name].errText = "Ce champ ne peut être vide.";
				}
			}
			this.validators[name].valid == false &&
			this.validators[name].errText !== ""
				? (this.check = false)
				: "";
			if (
				this.contract.early_cancellation &&
				name == "early_cancellation_duration" &&
				this.contract.early_cancellation_duration <= 0
			) {
				this.validators[name].errText = "Ce champ doit être supérieur à 0.";
			}
			this.$forceUpdate();
		},
		errText(name) {
			if (this.validators[name] && this.validators[name].errText !== "") {
				return this.validators[name].errText;
			}
		},
		styleValidator(name) {
			if (
				this.validators[name] &&
				this.validators[name].valid == false &&
				this.validators[name].errText !== ""
			) {
				switch (name) {
					case "society_id":
						return "border: 1px solid red !important;";
					case "commercial_id":
						return "border: 1px solid red !important; border-radius: 0 5px 5px 0;";
					case "early_cancellation_duration":
					case "engagement_duration":
					case "commentary":
					case "detail":
						return "border: 1px solid red !important; border-radius: 5px;";
					default:
						"";
				}
			} else if (this.validators[name] && this.validators[name].errText == "") {
				switch (name) {
					case "society_id":
						return "border: 1px solid green !important;";
					case "commercial_id":
						return "border: 1px solid green !important; border-radius: 0 5px 5px 0;";
					case "early_cancellation_duration":
					case "engagement_duration":
					case "commentary":
					case "detail":
						return "border: 1px solid green !important; border-radius: 5px;";
					default:
						"";
				}
			} else {
				return "border: none !important; border-radius: none;";
			}
		},

		closeMissionForm(value) {
			this.clickAddMission = value;
		},

		refreshData(value) {
			this.getAllProducts();
			this.missionsAdded += value;
			this.clickAddMission = false; // Close the form
		},

		/**
		 * Redirect to the previous page
		 */
		returnPrevRoute() {
			if (this.missionsAdded == 0 && this.checkPage == true) {
				this.$vs.notify({
					title: "Echec",
					text: "Vous devez ajouter au moins une prestation.",
				});
				return false;
			}
			this.$router.go(-1);
		},
	},
};
</script>

<style scoped>
.bottom {
	align-self: flex-end;
}

.center {
	align-self: center;
}

.center_div {
	justify-content: center;
}

.no_max_width > div {
	max-width: none;
}

.role_selector_container {
	justify-content: space-between;
	width: 40%;
}

.role_container {
	justify-content: center;
}

.space_div {
	margin: 5px;
}

.table_sizing {
	max-width: 800px;
}
</style>